
import consts from '../../../consts'
import { Notificacao } from './Notificacao'
import { useViewSistema } from '../../../hooks/useView'
import { useSistema } from '../../../hooks/useSistema'
import { ViewNavTab } from '../view/ViewNavTab'
import { useAPIService } from '../../../hooks/useAPIService'

function renderTabs(views = []) {
    return views.map(f => {
        return <ViewNavTab key={f.chave} {...f} />
    })
}

export function Header(){
    const { getImagem } = useAPIService()
    const { logout, usuario } = useSistema()
    const { views, addView } = useViewSistema()

    return (
        <nav className="main-header navbar navbar-expand text-sm border-bottom-0 navbar-dark navbar-primary pb-0 tema-ant-fundo">
            <div className="card card-primary card-tabs mb-0">
                <div className="card-header tema-ant-fundo p-0 border-bottom-0">
                    <ul className="nav nav-tabs border-bottom-0" id="menu-tab" role="tablist">
                        <li className="" key="hamburger">
                            <a href="/#" className="nav-link" data-widget="pushmenu" role="button">
                                <i className="fas fa-bars"></i>
                            </a>
                        </li>
                        {renderTabs(views)}
                    </ul>
                </div>
            </div>
            <ul className="navbar-nav ml-auto">
                <Notificacao />
                <li className="nav-item dropdown user-menu">
                    <a href="/#" className="nav-link dropdown-toggle" data-toggle="dropdown">
                        <img src={getImagem(usuario.foto)} className="user-image img-circle elevation-2" alt="Imagem Usuário" />
                        <span className="d-none d-md-inline">{usuario.nome}</span>
                    </a>
                    <ul className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                        <li className="user-header bg-primary tema-ant-fundo">
                            <img src={getImagem(usuario.foto)} className="img-circle elevation-2" alt="Imagem Usuário" />
                            <p>{usuario.nome} 
                                <a href="/#" onClick={() => {
                                    addView({
                                        id_menu: '999',
                                        icone: 'user-pen',
                                        chave: 'meus_dados', 
                                        nome: 'Meus Dados',
                                        titulo: 'Alterar Meus Dados',
                                    })
                                }}>
                                    &nbsp;<i className="fa fa-pen bg-primary tema-ant-fundo"> </i>
                                </a>
                            </p>
                        </li>
                        <li className="user-footer">
                            <a href={consts.linkApp} onClick={() => { 
                                logout()
                            }} className="btn btn-default btn-flat float-right">
                                <i className={`fas fa-sign-out-alt nav-icon`}></i> Sair
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </nav>
    )
}